import { render, staticRenderFns } from "./AdminDashboardView.vue?vue&type=template&id=acf8f7ce&scoped=true&"
import script from "./AdminDashboardView.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./AdminDashboardView.vue?vue&type=style&index=0&id=acf8f7ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf8f7ce",
  null
  
)

export default component.exports